import styled from '@emotion/styled'

interface Props {
  bold?: boolean
  resize?: boolean
}

const P2 = styled.p<Props>(
  ({ theme }) => theme.fontSmooth,
  ({ theme }) => ({
    color: theme.colors.text,
    fontFamily: theme.fonts.families.body,
    fontSize: '14px',
    fontWeight: 'normal',
    letterSpacing: '0.35px',
    lineHeight: '18px',
    [theme.mediaQueries.maxDesktop]: {
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.3px,',
    },
  }),
  ({ bold }) => bold && { fontWeight: 'bold' },
  ({ resize }) => !!resize && { fontSize: '0.7vw', lineHeight: '0.8vw' }
)

export default P2
